export default class BalanceSheetFilter {
    constructor() {
        this.type = null;
        this.year = null;
        this.project_id = null;
    }
}